import React, { useState, useEffect } from 'react';
import {
  Spin, Table, notification, Breadcrumb, Modal,Button,Row
} from 'antd';
import moment from 'moment';
import { EyeOutlined,PlusOutlined } from '@ant-design/icons';
import { get } from 'lodash';
import Cookies from 'js-cookie';
import API from '../../utils/Api';

const getTemplate = {
  Email: {
    table_name: 'email_campaign',
    content_name: 'email_template_content',
  },
  Push: {
    table_name: 'push_campaign',
    content_name: 'push_template_content',
  },
  SMS: {
    table_name: 'sms_campaign',
    content_name: 'sms_template_content',
  },
  Whatsapp:{
    table_name: 'whatsapp_campaign',
    content_name: 'ws_template_content',
  }
};

const CampaignTable = (properties) => {
  const {history} =properties
  const myApi = new API({});
  myApi.createEntity({ name: 'campaign' });
  const [appID] = useState(Cookies.get('appID'));
  const [appKey] = useState(Cookies.get("appKey"));
  const [loading, setLoading] = useState(false);
  const [campaignData, setCampaignData] = useState([]);
  const [modelVisible, setModelVisible] = useState(false);
  const [templateContent, setTemplateContent] = useState('');

  const fetchData = () => {
    setLoading(true);
    const fields = {
      params: { id: appID, appKey: appKey }
    };
    const apiArray = [myApi.endpoints.campaign.getAll(fields, {}, "get-campaign")];
    Promise.all(apiArray)
      .then((res) => {
        const data = get(res, '[0].data.data', []).map((item) => {
          return item.campaign;
        });
        setCampaignData(data);
        setLoading(false);
      })
      .catch((err) => notification.error({ message: err || 'Failed to load the data' }));
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleModelPreview = (data) => {
    const getTemplateName = getTemplate[data.campaign_type];
    const templateValue = `${get(data, [getTemplateName.table_name, getTemplateName.content_name], '')}`;
    setTemplateContent(templateValue);
    setModelVisible(true);
  };

  const handleCancel = () => {
    setModelVisible(false);
  };

  const columns = [
    {
      title: 'Campaign Name',
      dataIndex: 'campaign_name',
      width: 200,
    },
    {
      title: 'Campaign Type',
      dataIndex: 'campaign_type',
      width: 200,
    },
    {
      title: "Campaign Tags",
      dataIndex: "campaign_tags",
      width: 200,
    },
    {
      title: "Template Name",
      key: "ws_template_name",
      render: (item) => (
        <span>{item?.whatsapp_campaign?.ws_template_name}</span>
      ),
      width: 200,
    },
    {
      title: "Created",
      dataIndex: "creation_date",
      width: 200,
      render: (text) => (
        <span>{moment(text).isValid() ? moment(text).format("LLL") : ""}</span>
      ),
    },
    {
      title: 'Action',
      width: 200,
      render: (data) => (
        <EyeOutlined
          style={{ color: 'rgb(12, 99, 99)' }}
          onClick={() => handleModelPreview(data)}
        />
      ),
    },
  ];
  const onClickNewCampaign = () => {
    history.push('/campaign/create-new');
  };

  return (
    <>
      <div className='mx-2'>
      <Row className="justify-bt">
          <Breadcrumb>
            <Breadcrumb.Item>All Campaigns</Breadcrumb.Item>
          </Breadcrumb>
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={onClickNewCampaign}
          >
            Create new
          </Button>
          </Row>
      </div>
      <div className="box">
        <div className="box__content p-0">
          <Table
            className="grid-table"
            loading={loading}
            columns={columns}
            dataSource={campaignData}
          />
        </div>
        <Modal
          title="Template Content"
          visible={modelVisible}
          footer={null}
          onCancel={handleCancel}
        >
          <p dangerouslySetInnerHTML={{ __html: templateContent }} />
        </Modal>
      </div>
    </>
  );
};

export default CampaignTable;
